import D2C_ServiceData from './Data'

class D2C_ServiceElasticsearch extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = true
  static order = 26
  static typeName = 'elasticsearch'
  static typeTitle = 'Elasticsearch'
  static color = '#ffbb11'
  static fields = {
    ...D2C_ServiceData.fields,
    configs: {
      ...D2C_ServiceData.fields.configs,
      default: [
        {name: 'elasticsearch.yml', text: require('raw-loader!@/assets/configs/elasticsearch-elasticsearch.yml').default, custom: false},
      ],
    },
    env: {
      ...D2C_ServiceData.fields.env,
      default: [
        {name: 'ES_JAVA_OPTS', value: '-Xmx512m -Xms512m'},
      ],
    },
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        default: ['node'],
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'elasticsearch',
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 9200},
        {protocol: 'TCP', value: 9300},
      ],
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: '7.7.0',
      enum: ['5.6', '7.7.0'],
    },
    volumes: {
      ...D2C_ServiceData.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/data', dst: '/usr/share/elasticsearch/data', sync: false},
        {src: '/ebs/containers/$serviceName/configs', dst: '/usr/share/elasticsearch/config', sync: false},
      ],
    },
  }
}

export default D2C_ServiceElasticsearch
